import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Forward, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/calendar/calendar';

class FadvCalendarComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.range = false;
        this.dateChange = new EventEmitter();
        this.rangeStartChange = new EventEmitter();
        this.rangeEndChange = new EventEmitter();
    }
    ngOnChanges(changes) {
        var _a;
        const calendar = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement;
        if (!calendar)
            return;
        Object.keys(changes).forEach((key) => {
            const value = changes[key].currentValue;
            switch (key) {
                case 'date':
                case 'rangeStart':
                case 'rangeEnd':
                case 'minDate':
                case 'maxDate': {
                    calendar[key] = value ? new Date(value) : undefined;
                    break;
                }
                default:
                    calendar[key] = value;
                    break;
            }
        });
    }
    handleDateChange(e) {
        var _a;
        const { detail } = e;
        (_a = this.dateChange) === null || _a === void 0 ? void 0 : _a.emit(detail.date);
    }
    handleRangeChange(e) {
        var _a, _b;
        const { detail } = e;
        (_a = this.rangeStartChange) === null || _a === void 0 ? void 0 : _a.emit(detail.rangeStart);
        (_b = this.rangeEndChange) === null || _b === void 0 ? void 0 : _b.emit(detail.rangeEnd);
    }
}
FadvCalendarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCalendarComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvCalendarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvCalendarComponent, selector: "fadv-calendar", inputs: { range: "range", date: "date", rangeStart: "rangeStart", rangeEnd: "rangeEnd", minDate: "minDate", maxDate: "maxDate", datePattern: "datePattern" }, outputs: { dateChange: "dateChange", rangeStartChange: "rangeStartChange", rangeEndChange: "rangeEndChange" }, host: { listeners: { "fadv-calendar-date-change": "handleDateChange($event)", "fadv-calendar-range-change": "handleRangeChange($event)" } }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: '', isInline: true });
__decorate([
    Forward()
], FadvCalendarComponent.prototype, "range", void 0);
__decorate([
    Forward()
], FadvCalendarComponent.prototype, "date", void 0);
__decorate([
    Forward()
], FadvCalendarComponent.prototype, "rangeStart", void 0);
__decorate([
    Forward()
], FadvCalendarComponent.prototype, "rangeEnd", void 0);
__decorate([
    Forward()
], FadvCalendarComponent.prototype, "minDate", void 0);
__decorate([
    Forward()
], FadvCalendarComponent.prototype, "maxDate", void 0);
__decorate([
    Forward()
], FadvCalendarComponent.prototype, "datePattern", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCalendarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fadv-calendar', template: '' }]
        }], propDecorators: { range: [{
                type: Input
            }], date: [{
                type: Input
            }], rangeStart: [{
                type: Input
            }], rangeEnd: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], datePattern: [{
                type: Input
            }], dateChange: [{
                type: Output
            }], rangeStartChange: [{
                type: Output
            }], rangeEndChange: [{
                type: Output
            }], handleDateChange: [{
                type: HostListener,
                args: ['fadv-calendar-date-change', ['$event']]
            }], handleRangeChange: [{
                type: HostListener,
                args: ['fadv-calendar-range-change', ['$event']]
            }] } });

class FadvCalendarModule {
}
FadvCalendarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCalendarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvCalendarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvCalendarModule, declarations: [FadvCalendarComponent], imports: [FadvCommonModule], exports: [FadvCalendarComponent] });
FadvCalendarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCalendarModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCalendarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvCalendarComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvCalendarComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvCalendarComponent, FadvCalendarModule };
